import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-logo">ATIBA</div>
        <ul className="footer-links">
          <li><a href="#books">Books</a></li>
          <li><a href="#excerpt">Excerpts</a></li>
          <li><a href="#reviews">Reviews</a></li>
          <li><a href="#about">About</a></li>
          {/* <li><a href="#blog">Blog</a></li> */}
        </ul>
        <p className="footer-copy">&copy; 2026 Atiba. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
